import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import { initIntersections } from "./features/new-lazy-load";
import proportionalScroll from './features/proportional-scroll';
import {
    postMixin
} from './vue/mixins/lrplus';
import mostviewed from './features/most-viewed';
import {
    scrollFixedMixin
} from './features/scroll-fixed';
import VueMasonry from 'vue-masonry-css';
import {
    CarouselPlugin
  } from 'bootstrap-vue';


mostviewed();
initIntersections();
proportionalScroll();
const mixins = [postMixin, scrollFixedMixin];
window.temp = initMain(mixins, {
    SubscribeModal: () => import('./vue/components/subscribe-modal/SubscribeModal.vue'),
    FavoriteAddButton: () => import('./vue/components/favorite-add-button/FavoriteAddButton.vue'),
    PostListModal: () => import('./vue/components/post-list-modal/PostListModal.vue'),
    InterestNews: () => import('./vue/components/interest-news/InterestNews.vue'),
    Trends: () => import('./vue/components/trends/Trends.vue'),
}, [VueMasonry, CarouselPlugin]);
header();